<template>
  <div oncontextmenu="return false">
    <component :is="layout">
      <router-view />
      <slideout-panel />
    </component>
  </div>
</template>

<script>
import qz from '@/../own_modules/qz-tray/qz-tray'
import DefaultLayout from '@/layouts/DefaultLayout'
import CanvasLayout from '@/layouts/CanvasLayout'
import qzTrayMixin from '@/utils/mixins/qzTrayMixin'
import smartlookClient from 'smartlook-client'
import store from '@/store'
import moment from 'moment'
import Vue from 'vue'
import { mapState } from 'vuex'

export default {
  name: 'App',

  metaInfo: {
    title: '',
    titleTemplate: '%s | Vaporshop Point-of-Sale'
  },

  components: {
    CanvasLayout,
    DefaultLayout
  },

  mixins: [ qzTrayMixin ],

  computed: {
    ...mapState(['cashRegister']),
    layout () {
      return `${(this.$route.meta.layout || 'default')}-layout`
    }
  },

  watch: {
    cashRegister: {
      handler (cashRegister) {
        if (_.get(cashRegister, 'store.customThemePrimaryColor')) {
          this.$vuetify.theme.themes.light.primary = cashRegister.store.customThemePrimaryColor
        }
        if (_.get(cashRegister, 'store.customThemeSecondaryColor')) {
          this.$vuetify.theme.themes.light.secondary = cashRegister.store.customThemeSecondaryColor
        }
      }
    }
  },

  created () {
    // Fetch Cash Register Information
    if (this.$store.state.identifier) {
      this.$store.dispatch('FETCH_CASH_REGISTER', this.$store.state.identifier)
        .catch(data => { if (data && data.message) this.helpers.toastError(data.message) })
    }
    // Initialize a permanent printer connection with QZ Tray
    this.setupPrinterConnection()
    this.setLocale()
  },

  destroyed () {
    this.closePrinterConnection()
  },

  mounted () {
    smartlookClient.init('734ad230a673c74c3196d3bca5cce647210ffa45')
    smartlookClient.record({ forms: true, ips: true, emails: true, numbers: true })

    // Check each 30s if user token is still valid
    setInterval(function () {
      const isAuthenticated = store.getters['AUTH/isAuthenticated']
      if (isAuthenticated) {
        const now = moment()
        const differenceInMinutes = now.diff(moment(localStorage.getItem('lastApiCall')), 'minutes') + 1
        // Logout the user if last API call has been 30+ minutes ago
        if (differenceInMinutes >= 30) {
          store.dispatch('AUTH/LOGOUT', store.getters.token)
        }
      }
    }, 30000)
  },

  methods: {
    connectToPrinter () {
      this.initPrinterConnection()
        .then(() => this.$store.commit('SET_QZTRAY_INSTALLED', true))
        .catch(() => this.$store.commit('SET_QZTRAY_INSTALLED', false))
    },
    setLocale () {
      store.watch(() => store.getters['AUTH/user'], user => {
        if (user) {
          const locale = user.language || 'nl'
          Vue.i18n.set(locale)
          moment.locale(locale)
          this.$vuetify.lang.current = 'nl'
          return locale
        }
      })
    },

    setupPrinterConnection () {
      this.connectToPrinter()
      qz.websocket.setClosedCallbacks(() => {
        this.$store.commit('SET_QZTRAY_INSTALLED', false)
        setTimeout(() => {
          this.connectToPrinter()
        }, 100)
      })
    }
  }
}
</script>

<style lang="scss">
@import '@fortawesome/fontawesome-pro/css/all.min.css';
@import 'vuetify/dist/vuetify.min.css';
@import 'material-design-icons-iconfont/dist/material-design-icons.css';
@import 'vue-multiselect/dist/vue-multiselect.min.css';
@import 'vue2-animate/dist/vue2-animate.min.css';
@import url('https://fonts.googleapis.com/css?family=Roboto:100,300,400,700|Poppins');
@import '@/sass/_datatable.scss';
@import '@/sass/_helpers.scss';
@import '@/sass/_swal.scss';
@import '@/sass/_variables.scss';
@import '@/sass/_vuetify-overrides.scss';

body {
  overflow: hidden;
  font-family: 'Poppins', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 30px white inset;
}

::-webkit-scrollbar {
  display: none;
}

.container {
  padding: 24px;
}

a {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue